// SEO Configuration for all pages
import { appConfig } from '../../config/appConfig';
import { businessMetrics } from '../../config/businessMetrics';
export const seoConfig = {
  home: {
    title: 'Sell Your Business Fast - Expert M&A Advisory',
    description: `Sell your business in under ${businessMetrics.timeline.quickResults.displayText} with AMIVA+. Professional M&A advisory for businesses ${businessMetrics.businessSize.revenueRange.displayText}. Get your free business valuation instantly. ${businessMetrics.buyers.displayText} strategic buyers waiting.`,
    keywords: [
      'sell business fast',
      'quick business sale',
      '3 week business sale',
      'rapid exit strategy',
      'fast M&A advisor',
      'quick liquidity event'
    ],
    structuredData: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": appConfig.site.brandName,
      "url": appConfig.site.baseUrl,
      "potentialAction": {
        "@type": "SearchAction",
        "target": `${appConfig.site.baseUrl}/search?q={search_term_string}`,
        "query-input": "required name=search_term_string"
      }
    }
  },
  
  valuation: {
    title: 'Free Business Valuation Tool - Get Your Company Worth in Minutes',
    description: 'Get an instant, confidential business valuation with our AI-powered tool. Discover what your business is worth and how to maximize its value. Used by 1000+ business owners.',
    keywords: [
      'business valuation calculator',
      'free business valuation',
      'company valuation tool',
      'business worth calculator',
      'instant business appraisal',
      'AI business valuation',
      'SaaS valuation calculator',
      'EBITDA multiple calculator'
    ],
    structuredData: {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "AMIVA+ Business Valuation Tool",
      "applicationCategory": "BusinessApplication",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "ratingCount": "1247"
      }
    }
  },
  
  about: {
    title: 'About AMIVA+ - Boutique M&A Advisory by Former Founders',
    description: 'AMIVA+ was built by entrepreneurs who\'ve successfully exited 5 businesses. We specialize in fast, transparent business sales with $240M+ in closed deals.',
    keywords: [
      'boutique M&A firm',
      'founder-led advisory',
      'entrepreneur M&A advisor',
      'transparent business broker',
      'NYU Stern MBA advisor'
    ],
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'About', path: '/about' }
    ]
  },
  
  team: {
    title: 'Meet Our M&A Team - Industry Experts Who\'ve Been in Your Shoes',
    description: 'Our team of former founders and industry experts have closed $240M+ in deals. Available 24/7 to help you achieve your life-changing exit.',
    keywords: [
      'M&A team',
      'business advisors',
      'exit planning experts',
      'merger advisors',
      'acquisition specialists'
    ],
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'Team', path: '/team' }
    ]
  },
  
  process: {
    title: 'Our 6-Month Exit Process - From Valuation to Closing',
    description: 'Learn our proven 6-month process for selling your business at maximum value. From initial valuation to final closing, we handle everything with complete transparency.',
    keywords: [
      'M&A process',
      'business sale process',
      'exit strategy timeline',
      '6 month business sale',
      'selling business steps'
    ],
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'Process', path: '/process' }
    ]
  },
  
  successStories: {
    title: 'Success Stories - $240M+ in Successful Business Exits',
    description: 'Read how we\'ve helped businesses achieve life-changing exits. Real stories from founders who sold for 35% above initial offers.',
    keywords: [
      'M&A success stories',
      'business sale testimonials',
      'exit success cases',
      'business sale results',
      'M&A case studies'
    ],
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'Success Stories', path: '/success-stories' }
    ]
  },
  
  faq: {
    title: 'M&A FAQ - Everything About Selling Your Business',
    description: 'Get answers to common questions about business valuation, the M&A process, timing, fees, and what to expect when selling your business.',
    keywords: [
      'M&A FAQ',
      'selling business questions',
      'business valuation FAQ',
      'exit planning questions',
      'M&A process explained'
    ],
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'FAQ', path: '/faq' }
    ],
    structuredData: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "How long does it take to sell a business?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": `With AMIVA+, the typical timeline is ${businessMetrics.timeline.fullProcess.displayText} from engagement to closing. We can generate initial offers in ${businessMetrics.timeline.initialOffers.detailText}.`
          }
        },
        {
          "@type": "Question",
          "name": "What size businesses does AMIVA+ work with?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": `We specialize in businesses with ${businessMetrics.businessSize.revenueRange.displayText} in annual revenue, though we occasionally work with larger transactions.`
          }
        },
        {
          "@type": "Question",
          "name": "How much does AMIVA+ charge?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We work on a success fee basis only. No retainers, no upfront fees. We only get paid when you successfully close your transaction."
          }
        },
        {
          "@type": "Question",
          "name": "Is the valuation really free?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, our AI-powered business valuation tool is completely free with no obligations. You'll get an instant valuation report based on your business metrics."
          }
        },
        {
          "@type": "Question",
          "name": "How do you find buyers for my business?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": `We have access to nearly ${businessMetrics.buyers.qualifiedText} including strategic acquirers, private equity firms, and individual buyers who are specifically looking for businesses like yours.`
          }
        }
      ]
    }
  },
  
  businessValuation: {
    title: 'Professional Business Valuation Services - Know Your Worth',
    description: 'Get an accurate, market-based business valuation from M&A experts. We use AI analysis, financial modeling, and recent comparables to determine your true business value.',
    keywords: [
      'professional business valuation',
      'company appraisal services',
      'business worth assessment',
      'M&A valuation services',
      'EBITDA valuation',
      'SDE multiple valuation'
    ],
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'Services', path: '/services' },
      { name: 'Business Valuation', path: '/services/business-valuation' }
    ],
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "Business Valuation",
      "provider": {
        "@type": "Organization",
        "name": appConfig.site.organizationName
      },
      "areaServed": {
        "@type": "Country",
        "name": "United States"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Valuation Methods",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Revenue Multiple Valuation",
              "description": "Best for businesses under $5M EBITDA"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "EBITDA Multiple Valuation",
              "description": "Best for businesses over $1M EBITDA"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "SDE Multiple Valuation",
              "description": "Best for owner-operated businesses"
            }
          }
        ]
      }
    }
  },
  
  buyerSourcing: {
    title: 'Strategic Buyer Sourcing - 200,000 Qualified Buyers for Your Business',
    description: 'We don\'t just list your business. We have access to nearly 200,000 strategic buyers who will pay premium prices. Average 3.5 competing offers per business.',
    keywords: [
      'business buyer sourcing',
      'find business buyers',
      'strategic buyer search',
      'M&A buyer network',
      'private equity buyers',
      'strategic acquirers'
    ],
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'Services', path: '/services' },
      { name: 'Buyer Sourcing', path: '/services/buyer-sourcing' }
    ],
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "Buyer Sourcing and M&A Advisory",
      "provider": {
        "@type": "Organization",
        "name": appConfig.site.organizationName
      },
      "areaServed": {
        "@type": "Country",
        "name": "United States"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5",
        "reviewCount": "89"
      }
    }
  }
};

